var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageWithLayout',[_c('div',{staticClass:"inner_section"},[_c('BoardList',{attrs:{"title":"공지&이벤트","dataList":_vm.viewModel.NoticeDataList,"paginationData":_vm.viewModel.paginationData,"itemRouteName":"NoticeDetail"},on:{"onClickBtn":function($event){return _vm.viewModel.getNoticeList()}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }